import { module } from 'modujs';


export default class extends module {
    constructor(m) {
        super(m);
        this.carousel = this.$('carousel')[0]
        if(!this.carousel) this.carousel = this.el

        this.arrowNext = this.$('next')[0]
        this.arrowPrev = this.$('prev')[0]
    }

    init() {
        this.length = this.$('item').length

        const args = {
            speed: 1000,
            loop: true,
            spaceBetween: 0,
            loopedSlides: 2,
            grabCursor: true,
            slidesPerView: 1,
            threshold: 2,
            parallax: true,
            navigation: {
                nextEl: this.arrowNext,
                prevEl: this.arrowPrev,
            },
        }

        if(this.length > 1) {
            this.carousel = new Swiper(this.carousel, args)
        }

        if(this.length < 2) {
            this.arrowPrev.classList.add('is-invisible')
            this.arrowNext.classList.add('is-invisible')
        }
    }

    destroy() {
        if(this.carousel && this.carousel.destroy) this.carousel.destroy(true, true)
    }
}
